define('CookieConsentCloseOverlayHotfix', [
    'jQuery'
], function CookieConsentCloseOverlayHotfix(
    jQuery
) {
    'use strict';

    var cookieName = 'trackingConsentCookie';
    var cleanupDelays = [0, 100, 500, 1500, 3000];
    var focusableSelector = 'a, button, textarea, input, select, form';

    function hasConsentCookie() {
        return new RegExp('(?:^|;\\s*)' + cookieName + '=').test(document.cookie || '');
    }

    function restoreFocusTrap() {
        jQuery(document)
            .find(focusableSelector)
            .filter('[aria-hidden="true"][tabindex="-1"]')
            .removeAttr('disabled')
            .removeAttr('aria-hidden')
            .removeAttr('tabindex');
    }

    function cleanupCookieConsentUi(force) {
        var modalVisible = jQuery('#cookieconsentModal').is(':visible');
        var bannerExists = jQuery('#cookieconsent-banner').length > 0;
        var backdropVisible = jQuery('#cookieConsentBackdrop').is(':visible');

        if (!force && !hasConsentCookie()) {
            return;
        }

        if (!force && modalVisible) {
            return;
        }

        if (!force && !bannerExists && !backdropVisible) {
            return;
        }

        jQuery('#cookieconsent-banner').remove();
        jQuery('#cookieConsentBackdrop').addClass('hide');

        jQuery('.shopping-layout-header, .myaccount-layout-header, .checkout-layout-header')
            .removeClass('cookieconsent-overlay-banner-open');

        if (force) {
            jQuery('#cookieconsentModal').modal && jQuery('#cookieconsentModal').modal('hide');
            jQuery('.modal-backdrop').remove();
            jQuery('body').removeClass('modal-open').css('padding-right', '');
        }

        restoreFocusTrap();
    }

    function scheduleCleanup(force) {
        cleanupDelays.forEach(function schedule(delay) {
            window.setTimeout(function cleanup() {
                cleanupCookieConsentUi(force);
            }, delay);
        });
    }

    function observeLateBannerRender() {
        if (!window.MutationObserver || !document.body) {
            return;
        }

        new MutationObserver(function onMutation() {
            if (hasConsentCookie()) {
                scheduleCleanup(false);
            }
        }).observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    return {
        mountToApp: function mountToApp() {
            scheduleCleanup(false);
            observeLateBannerRender();

            jQuery('body').on(
                'click',
                '[data-action="acceptAll"], [data-action="rejectAll"], [data-action="saveSettings"]',
                function onConsentCloseAction() {
                    scheduleCleanup(true);
                }
            );
        }
    };
});
